import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})

export class EncryptionService {
    set(value: string): string {
       var key= CryptoJS.enc.Base64.parse('iGscoUs9uOuvaK0AGa3MW6dsPnDPM/ER86NBHkvUyDw=');
        var iv= CryptoJS.enc.Base64.parse('E4ydVU5lhEgxYIdSQzHNRA==');
        var encrypted = CryptoJS.AES.encrypt(value, key, {
            iv: iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        var result=CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
        return result;
    }
}